import {
  Flex,
  VStack,
  Image,
  Tooltip,
  Card,
  CardBody,
  Heading,
  Text,
  Box,
  Divider,
  HStack,
} from "@chakra-ui/react";
import LoginComponent from "../components/login-inputs";
import imagelogo from "../images/trr_cenze_comrcio_de_combustveis_e_derivados_logo.png";
import { Link, useNavigate } from "react-router-dom";
import NexusLogo from "../images/logo_nexus_consult.png";
import { MdSecurity, MdSupport } from "react-icons/md";

const LoginPage = () => {
  const navigate = useNavigate();

  return (
    <Flex
      minHeight="100vh"
      bgGradient="linear(135deg, #007abe 0%, #005a8a 50%, #003d5c 100%)"
      alignItems="center"
      justifyContent="center"
      px={{ base: 3, md: 6 }}
      py={{ base: 3, md: 4 }}
      position="relative"
      _before={{
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bg: 'url(\'data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.03"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\')',
        opacity: 0.4,
        pointerEvents: "none",
      }}
    >
      <Card
        bg="white"
        borderRadius="2xl"
        boxShadow="2xl"
        border="none"
        w={{ base: "100%", sm: "90%", md: "420px", lg: "440px" }}
        maxW="460px"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
          bgGradient: "linear(to-r, #007abe, #c0a316)",
        }}
      >
        <CardBody p={{ base: 4, sm: 5, md: 6 }}>
          <VStack spacing={{ base: 3, sm: 4, md: 4 }} align="stretch">
            {/* Header com Logo */}
            <VStack spacing={{ base: 2, md: 2 }}>
              <Image
                src={imagelogo}
                alt="CENZE Logo"
                maxW={{ base: "100px", sm: "120px", md: "140px" }}
                maxH={{ base: "100px", sm: "120px", md: "140px" }}
                mx="auto"
                onClick={() => navigate("/admin")}
                cursor="pointer"
                _hover={{ transform: "scale(1.05)" }}
                transition="transform 0.3s"
              />
              <VStack spacing={0}>
                <Heading
                  as="h1"
                  size={{ base: "md", sm: "lg", md: "xl" }}
                  color="gray.800"
                  fontWeight="700"
                  textAlign="center"
                  letterSpacing="-0.5px"
                >
                  Bem-vindo
                </Heading>
                <Text
                  color="gray.600"
                  textAlign="center"
                  fontSize={{ base: "xs", sm: "sm" }}
                  fontWeight="500"
                >
                  Entre com suas credenciais para acessar o sistema
                </Text>
              </VStack>
            </VStack>

            <Divider borderColor="gray.200" />

            {/* Formulário de Login */}
            <Box>
              <LoginComponent />
            </Box>

            {/* Footer com informações */}
            <VStack spacing={1} pt={0}>
              <Divider borderColor="gray.200" />
              <HStack
                spacing={3}
                fontSize={{ base: "9px", sm: "10px" }}
                color="gray.500"
                justify="center"
                flexWrap="wrap"
              >
                <HStack spacing={0.5}>
                  <MdSecurity size="10px" />
                  <Text>Conexão segura</Text>
                </HStack>
                <HStack spacing={0.5}>
                  <MdSupport size="10px" />
                  <Text>Suporte técnico</Text>
                </HStack>
              </HStack>
              <Tooltip
                label="NEXUS CONSULTORIA"
                fontSize="xs"
                placement="top"
                hasArrow
              >
                <Link
                  href="https://www.nexusconsultoriams.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                  _hover={{ opacity: 0.8 }}
                  transition="opacity 0.2s"
                >
                  <Image
                    src={NexusLogo}
                    alt="Nexus Consultoria"
                    borderRadius="full"
                    boxSize={{ base: "32px", sm: "38px", md: "44px" }}
                    style={{ objectFit: "contain" }}
                    cursor="pointer"
                    opacity={0.6}
                  />
                </Link>
              </Tooltip>
            </VStack>
          </VStack>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default LoginPage;
